// extracted by mini-css-extract-plugin
module.exports = {"heading":"following_heading__1VP4d","content":"following_content__21k0O","button":"following_button__RKhKy","sending":"following_sending__1_qum"};